import { __decorate, __metadata, __param } from 'tslib';
import { Input, Output, Component, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef, EventEmitter, Injectable, Inject, PLATFORM_ID, InjectionToken, Optional, NgModule } from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DOCUMENT, isPlatformBrowser, CommonModule } from '@angular/common';
import { UkFormControlsModule } from '@uikit/components/uk-form-controls';
import { UkEmailPipe, UkPhonePipe, UIKitCommonModule } from '@uikit/components/common';
import { UkDropdownModule } from '@uikit/components/uk-dropdown';
import { UIKitIconsModule } from '@uikit/components/uk-icons';
import { UKValidators } from '@uikit/components/uk-validators';
import { Subject, merge, fromEvent, from, timer, Subscription } from 'rxjs';
import { throttleTime, tap, filter, map } from 'rxjs/operators';

var RecoveryField;
(function (RecoveryField) {
    RecoveryField["password"] = "Username";
    RecoveryField["username"] = "Email";
})(RecoveryField || (RecoveryField = {}));

var UkRecoveryComponent = /** @class */ (function () {
    function UkRecoveryComponent(cdr, fb) {
        this.cdr = cdr;
        this.fb = fb;
        this.btnLegend = '';
        this.topLegend = '';
        this.returnParentView = new EventEmitter();
        this.field = new EventEmitter();
        this.visible = false;
        this.form = this.fb.group({
            recoveryField: [''],
            value: ['']
        });
    }
    UkRecoveryComponent.prototype.continue = function () { this.field.emit(this.form.value); };
    UkRecoveryComponent.prototype.recoverByEmail = function () {
        this.legendRecoveryField = RecoveryField.username;
        this.form.controls['value'].setValidators(UKValidators.validEmail);
        this.form.controls['recoveryField'].setValue(RecoveryField.username.toLowerCase());
    };
    UkRecoveryComponent.prototype.recoverByUsername = function () {
        this.legendRecoveryField = RecoveryField.password;
        this.form.controls['value'].setValidators(UKValidators.validUserName);
        this.form.controls['recoveryField'].setValue(RecoveryField.password.toLowerCase());
    };
    UkRecoveryComponent.prototype.show = function () {
        this.visible = true;
        this.cdr.markForCheck();
    };
    UkRecoveryComponent.prototype.hide = function () {
        this.visible = false;
        this.form.controls['value'].reset();
        this.returnParentView.emit(true);
        this.cdr.markForCheck();
    };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], UkRecoveryComponent.prototype, "btnLegend", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], UkRecoveryComponent.prototype, "topLegend", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], UkRecoveryComponent.prototype, "returnParentView", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], UkRecoveryComponent.prototype, "field", void 0);
    UkRecoveryComponent = __decorate([
        Component({
            selector: 'uk-recovery',
            template: "<ng-container *ngIf=\"visible\">\r\n    <div class=\"fcontainer\">\r\n        <div class=\"frow center\">\r\n            <div class=\"fcol-xs-12 fcol-md-9 fcol-lg-6\">\r\n                <h3>{{topLegend}}</h3>\r\n            </div>\r\n        </div>\r\n        <div class=\"frow center\">\r\n            <div class=\"fcol-sm-8 fcol-md-5 center\">\r\n                <form [formGroup]=\"form\">\r\n                    <br>\r\n                    <uk-form-field label=\"{{legendRecoveryField}}\">\r\n                        <input ukInput required=\"true\" name=\"field\" formControlName=\"value\">\r\n                    </uk-form-field>\r\n                    <div class=\"uk-btn-container\">\r\n                        <button class=\"uk-btn secondary solid\" [disabled]=\"!form.valid\" (click)=\"continue()\">{{btnLegend}}</button>\r\n                        <button class=\"uk-btn back\" (click)=\"hide()\">Back</button>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</ng-container>\r\n",
            encapsulation: ViewEncapsulation.None,
            changeDetection: ChangeDetectionStrategy.OnPush
        }),
        __metadata("design:paramtypes", [ChangeDetectorRef, FormBuilder])
    ], UkRecoveryComponent);
    return UkRecoveryComponent;
}());

var UkLoginComponent = /** @class */ (function () {
    function UkLoginComponent(fb) {
        this.fb = fb;
        this.topLegend = '';
        this.btnLegend = '';
        this.nextStep = new EventEmitter();
        this.visible = true;
        this.form = this.fb.group({
            username: ['', [Validators.required, UKValidators.validUserName]],
            password: ['', Validators.required]
        });
    }
    UkLoginComponent.prototype.ngOnInit = function () {
        this.forgotPassword.recoverByUsername();
        this.forgotPassword.hide();
        this.forgotUsername.recoverByEmail();
        this.forgotUsername.hide();
    };
    UkLoginComponent.prototype.continue = function () {
        if (this.form.valid) {
            this.nextStep.emit(this.form.value);
        }
        else {
            this.form.markAllAsTouched();
        }
    };
    UkLoginComponent.prototype.recoverPass = function () {
        var _this = this;
        var valueChange = this.forgotPassword.field.subscribe(function (v) {
            _this.nextStep.emit(v);
        });
        var showComponent = this.forgotPassword.returnParentView.subscribe(function (v) {
            if (v) {
                _this.visible = true;
                valueChange.unsubscribe();
                showComponent.unsubscribe();
                _this.forgotPassword.hide();
            }
        });
        this.visible = false;
        this.forgotPassword.show();
    };
    UkLoginComponent.prototype.recoverUser = function () {
        var _this = this;
        var valueChange = this.forgotUsername.field.subscribe(function (v) {
            _this.nextStep.emit(v);
        });
        var showComponent = this.forgotUsername.returnParentView.subscribe(function (v) {
            if (v) {
                _this.visible = true;
                valueChange.unsubscribe();
                showComponent.unsubscribe();
                _this.forgotUsername.hide();
            }
        });
        this.visible = false;
        this.forgotUsername.show();
    };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], UkLoginComponent.prototype, "topLegend", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], UkLoginComponent.prototype, "btnLegend", void 0);
    __decorate([
        Input(),
        __metadata("design:type", UkRecoveryComponent)
    ], UkLoginComponent.prototype, "forgotPassword", void 0);
    __decorate([
        Input(),
        __metadata("design:type", UkRecoveryComponent)
    ], UkLoginComponent.prototype, "forgotUsername", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], UkLoginComponent.prototype, "nextStep", void 0);
    UkLoginComponent = __decorate([
        Component({
            selector: 'uk-login',
            template: "<div class=\"fcontainer\" *ngIf=\"visible\">\r\n  <div class=\"frow center\">\r\n    <div class=\"fcol-xs-12 fcol-md-9 fcol-lg-6\">\r\n      <h3>{{topLegend}}</h3>\r\n    </div>\r\n  </div>\r\n  <div class=\"frow center\">\r\n    <div class=\"fcol-sm-8 fcol-md-5 center\">\r\n      <form [formGroup]=\"form\">\r\n        <uk-form-field label=\"Username\">\r\n          <input ukInput required formControlName=\"username\">\r\n        </uk-form-field>\r\n        <uk-form-field label=\"Password\">\r\n          <input ukInput type=\"password\" minlength=\"8\" maxlength=\"50\" required formControlName=\"password\">\r\n          <uk-error *ngIf=\"form.get('password').errors?.minlength\">\r\n            Please enter at least 8 characters\r\n          </uk-error>\r\n        </uk-form-field>\r\n        <div class=\"uk-btn-container\">\r\n          <button class=\"uk-btn secondary solid center\" (click)=\"continue()\">{{btnLegend}}</button>\r\n        </div>\r\n        <br>\r\n        <p class=\"uk-text-center\">Forgot <a (click)=\"recoverUser()\">username</a> or <a (click)=\"recoverPass()\">password</a>?</p>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
            encapsulation: ViewEncapsulation.None
        }),
        __metadata("design:paramtypes", [FormBuilder])
    ], UkLoginComponent);
    return UkLoginComponent;
}());

var UkVerificationMethodsComponent = /** @class */ (function () {
    function UkVerificationMethodsComponent() {
        this.nextStep = new EventEmitter();
    }
    Object.defineProperty(UkVerificationMethodsComponent.prototype, "methods", {
        get: function () { return this._methods; },
        set: function (value) {
            if (value) {
                this._methods = value;
                this.methods.forEach(function (m) {
                    switch (m.type) {
                        case 'sms':
                            m.icon = 'chat';
                            m.message = 'Text Message to' + new UkPhonePipe().maskTransform(m.value);
                            break;
                        case 'email':
                            m.icon = 'messages';
                            m.message = 'Email to ' + new UkEmailPipe().transform(m.value);
                            break;
                    }
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    UkVerificationMethodsComponent.prototype.continue = function ($event) { this.nextStep.emit({ type: $event.type, value: $event.value }); };
    __decorate([
        Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], UkVerificationMethodsComponent.prototype, "methods", null);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], UkVerificationMethodsComponent.prototype, "nextStep", void 0);
    UkVerificationMethodsComponent = __decorate([
        Component({
            selector: 'uk-verification-methods',
            template: "<div class=\"fcontainer\">\r\n    <div class=\"frow center\">\r\n        <div class=\"fcol-sm-10 fcol-md-6 center\">\r\n            <h3>To confirm your identity and ensure your account is secure, please select a method to deliver your one-time verification code.</h3>\r\n            <br>\r\n        </div>\r\n    </div>\r\n    <div class=\"frow center\">\r\n        <div class=\"fcol-md-6 uk-btn-container center\">\r\n            <p class=\"center\">How would you like to receive your access code?</p>\r\n            <br>\r\n            <ng-container *ngFor=\"let method of methods\">\r\n                <button class=\"uk-text-justify uk-btn fit outline primary\" ukIcon=\"{{method?.icon}}\" (click)=\"continue(method)\">{{ method?.message }}</button>\r\n                <br>\r\n            </ng-container>\r\n        </div>\r\n    </div>\r\n</div>",
            encapsulation: ViewEncapsulation.None
        })
    ], UkVerificationMethodsComponent);
    return UkVerificationMethodsComponent;
}());

var UkVerificationCodeComponent = /** @class */ (function () {
    function UkVerificationCodeComponent(fb) {
        this.fb = fb;
        this.otp = '';
        this.allowRemember = false;
        this.nextStep = new EventEmitter();
        this.return = new EventEmitter();
        this.retry = new EventEmitter();
        this.form = this.fb.group({
            code: ['', Validators.required],
            remember: [false]
        });
    }
    Object.defineProperty(UkVerificationCodeComponent.prototype, "method", {
        get: function () { return this._method; },
        set: function (value) {
            this._method = value;
            if (value) {
                switch (this.method.type) {
                    case 'sms':
                        this.method.message = "We've sent a SMS with your verification code to " + new UkPhonePipe().maskTransform(this.method.value);
                        break;
                    case 'email':
                        this.method.message = "We've sent an email with your verification code to " + new UkEmailPipe().transform(this.method.value);
                        break;
                }
                this.form.controls['code'].setValue(this.otp);
            }
        },
        enumerable: true,
        configurable: true
    });
    UkVerificationCodeComponent.prototype.continue = function () { this.nextStep.emit(this.form.value); };
    UkVerificationCodeComponent.prototype.resend = function () { this.retry.emit(); };
    UkVerificationCodeComponent.prototype.returnView = function () { this.return.emit(); };
    __decorate([
        Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], UkVerificationCodeComponent.prototype, "method", null);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], UkVerificationCodeComponent.prototype, "otp", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], UkVerificationCodeComponent.prototype, "allowRemember", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], UkVerificationCodeComponent.prototype, "nextStep", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], UkVerificationCodeComponent.prototype, "return", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], UkVerificationCodeComponent.prototype, "retry", void 0);
    UkVerificationCodeComponent = __decorate([
        Component({
            selector: 'uk-verification-code',
            template: "<div class=\"fcontainer\" >\r\n    <form [formGroup]=\"form\">\r\n        <div class=\"frow center\">\r\n            <div class=\"fcol-sm-10  fcol-md-6 uk-text-center\">\r\n                <h3>{{method?.message}}.</h3>\r\n                <br>\r\n            </div>\r\n        </div>\r\n        <div class=\"frow center\">\r\n            <div class=\"fcol-xs-6 fcol-sm-4 uk-btn-container center\">\r\n                <p class=\"center\">Enter your code and click continue</p>\r\n                <input ukInput formControlName=\"code\">\r\n                <br>\r\n                <span class=\"uk-text-center\">Didn\u2019t receive your code? <a (click)=\"resend()\">Resend</a></span>\r\n            </div>\r\n        </div>\r\n        <div class=\"frow center\" *ngIf=\"allowRemember\">\r\n            <div class=\"fcol-sm-8 fcol-md-6 uk-btn-container center\">\r\n                <br>\r\n                <input type=\"checkbox\" id=\"chkRememberAccount\" formControlName=\"remember\">\r\n                <label for=\"chkRememberAccount\">Remember this device to make future logins easier.</label>\r\n            </div>\r\n        </div>\r\n        <div class=\"frow center\">\r\n            <div class=\"fcol-sm-6 fcol-md-4 uk-btn-container\">\r\n                <br>\r\n                <button class=\"uk-btn solid secondary center\" [disabled]=\"!form.valid\" (click)=\"continue()\">Continue</button>\r\n                <button class=\"uk-btn back\" (click)=\"returnView()\">Back</button>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</div>\r\n",
            encapsulation: ViewEncapsulation.None
        }),
        __metadata("design:paramtypes", [FormBuilder])
    ], UkVerificationCodeComponent);
    return UkVerificationCodeComponent;
}());

var UkSecurityQuestionsComponent = /** @class */ (function () {
    function UkSecurityQuestionsComponent(fb, cdr) {
        this.fb = fb;
        this.cdr = cdr;
        this.nextStep = new EventEmitter();
        this.form = this.fb.group({
            questions: this.fb.array([])
        });
    }
    Object.defineProperty(UkSecurityQuestionsComponent.prototype, "requiredQuestions", {
        get: function () { return this._requiredQuestions; },
        set: function (value) {
            if (typeof (value) !== 'number')
                value = 0;
            this._requiredQuestions = new Array(value);
            for (var i = 0; i < this._requiredQuestions.length; i++) {
                this._requiredQuestions[i] = 0;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UkSecurityQuestionsComponent.prototype, "questions", {
        get: function () { return this._questions; },
        set: function (value) {
            var _this = this;
            if (Array.isArray(value)) {
                this._questions = value.map(function (q) { return ({ text: q, isSelected: false }); });
                var arrayForm_1 = this.getArrayControls('questions');
                this.requiredQuestions.forEach(function (_) {
                    arrayForm_1.push(_this.fb.group({
                        question: ['', Validators.required],
                        answer: ['', Validators.required]
                    }));
                });
                this.cdr.detectChanges();
            }
        },
        enumerable: true,
        configurable: true
    });
    UkSecurityQuestionsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.form.valueChanges.subscribe(function (values) {
            _this.questions.forEach(function (s) { return s.isSelected = false; });
            values.questions.forEach(function (q, i) {
                // Validate just one selection per question
                var idx = _this.questions.findIndex(function (item) { return item.text == q.question; });
                if (idx >= 0)
                    _this._questions[idx].isSelected = true;
                // Validate different answers
                if (q.answer != '') {
                    values.questions.findIndex(function (item, j) { return item.answer == q.answer && j != i; }) > -1 ?
                        _this.form.get('questions.' + i + '.answer').setErrors({ "notUnique": true }) :
                        _this.form.get('questions.' + i + '.answer').setErrors(null);
                }
            });
        });
    };
    UkSecurityQuestionsComponent.prototype.getArrayControls = function (control) {
        return this.form.get(control);
    };
    UkSecurityQuestionsComponent.prototype.continue = function () { this.nextStep.emit(this.form.value); };
    __decorate([
        Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], UkSecurityQuestionsComponent.prototype, "requiredQuestions", null);
    __decorate([
        Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], UkSecurityQuestionsComponent.prototype, "questions", null);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], UkSecurityQuestionsComponent.prototype, "nextStep", void 0);
    UkSecurityQuestionsComponent = __decorate([
        Component({
            selector: 'uk-security-questions',
            template: "<div class=\"fcontainer\">\r\n    <form [formGroup]=\"form\">\r\n        <div formArrayName=\"questions\">\r\n            <div class=\"frow center\" *ngFor=\"let x of requiredQuestions; let i = index\">\r\n                <div class=\"fcol-xs fcol-sm-7 fcol-md-6 fcol-lg-5\" formGroupName=\"{{i}}\">\r\n                    <uk-form-field label=\"Question {{i+1}}\">\r\n                        <uk-dropdown required=\"true\" placeholder=\"Please select a question\" formControlName=\"question\">\r\n                            <ng-container *ngFor=\"let question of questions\">\r\n                                <uk-option value=\"{{question.text}}\" *ngIf=\"!question.isSelected\">\r\n                                    {{question.text}}\r\n                                </uk-option>\r\n                            </ng-container>\r\n                        </uk-dropdown>\r\n                    </uk-form-field>\r\n                    <uk-form-field label=\"Your answer (not case-sensitive)\">\r\n                        <input ukInput required=\"true\" formControlName=\"answer\">\r\n                        <uk-error *ngIf=\"form.get('questions.'+i+'.answer')?.errors?.notUnique\">\r\n                            Please do not repeat answers\r\n                        </uk-error>\r\n                    </uk-form-field>\r\n                </div>\r\n                <br>\r\n            </div>\r\n            <div class=\"frow center\">\r\n                <div class=\"fcol-xs-8 fcol-sm-4 uk-btn-container\">\r\n                    <button class=\"uk-btn solid secondary\" [disabled]=\"!form.valid\" (click)=\"continue()\">Finish</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</div>",
            encapsulation: ViewEncapsulation.None,
            changeDetection: ChangeDetectionStrategy.Default
        }),
        __metadata("design:paramtypes", [FormBuilder, ChangeDetectorRef])
    ], UkSecurityQuestionsComponent);
    return UkSecurityQuestionsComponent;
}());

// This service is based on the `ng2-cookies` package which sadly is not a service and does
var UkCookieService = /** @class */ (function () {
    function UkCookieService(document, 
    // Get the `PLATFORM_ID` so we can check if we're in a browser.
    platformId) {
        this.document = document;
        this.platformId = platformId;
        this.documentIsAccessible = isPlatformBrowser(this.platformId);
    }
    /**
     * Checks if a cookie can be accessed or found
     * @param name Cookie name
     * @returns boolean
     */
    UkCookieService.prototype.check = function (name) {
        if (!this.documentIsAccessible) {
            return false;
        }
        name = encodeURIComponent(name);
        var regExp = this.getCookieRegExp(name);
        var exists = regExp.test(this.document.cookie);
        return exists;
    };
    /**
     * Gets the value of the cookie
     * @param name Cookie name
     * @returns any
     */
    UkCookieService.prototype.get = function (name) {
        if (this.documentIsAccessible && this.check(name)) {
            name = encodeURIComponent(name);
            var regExp = this.getCookieRegExp(name);
            var result = regExp.exec(this.document.cookie);
            return decodeURIComponent(result[1]);
        }
        else {
            return '';
        }
    };
    /**
     * Returns a map of key-value pairs for cookies that can be accessed
     * @returns map{}
     */
    UkCookieService.prototype.getAll = function () {
        if (!this.documentIsAccessible) {
            return {};
        }
        var cookies = {};
        var document = this.document;
        if (document.cookie && document.cookie !== '') {
            var split = document.cookie.split(';');
            for (var i = 0; i < split.length; i += 1) {
                var currentCookie = split[i].split('=');
                currentCookie[0] = currentCookie[0].replace(/^ /, '');
                cookies[decodeURIComponent(currentCookie[0])] = decodeURIComponent(currentCookie[1]);
            }
        }
        return cookies;
    };
    /**
     * Sets a cookie with specified name and value
     * @param name     Cookie name
     * @param value    Cookie value
     * @param expires  Number of minutes until the cookie expires
     * @param path     Cookie path
     * @param domain   Cookie domain
     * @param secure   Secure flag
     * @param sameSite OWASP samesite token `Lax` or `Strict`
     */
    UkCookieService.prototype.set = function (name, value, expires, path, domain, secure, sameSite) {
        if (!this.documentIsAccessible) {
            return;
        }
        var cookieString = encodeURIComponent(name) + '=' + encodeURIComponent(value) + ';';
        if (expires) {
            if (typeof expires === 'number') {
                var dateExpires = new Date(new Date().getTime() + expires * 1000 * 60 / 60);
                cookieString += 'expires=' + dateExpires.toUTCString() + ';';
            }
            else {
                cookieString += 'expires=' + expires.toUTCString() + ';';
            }
        }
        if (path) {
            cookieString += 'path=' + path + ';';
        }
        if (domain) {
            cookieString += 'domain=' + domain + ';';
        }
        if (secure) {
            cookieString += 'secure;';
        }
        if (sameSite) {
            cookieString += 'sameSite=' + sameSite + ';';
        }
        this.document.cookie = cookieString;
    };
    /**
     * Deletes a cookie with the specified name
     * @param name   Cookie name
     * @param path   Cookie path
     * @param domain Cookie domain
     */
    UkCookieService.prototype.delete = function (name, path, domain) {
        if (!this.documentIsAccessible) {
            return;
        }
        this.set(name, '', new Date('Thu, 01 Jan 1970 00:00:01 GMT'), path, domain);
    };
    /**
     * Deletes all cookies that can currently be accessed
     * @param path   Cookie path
     * @param domain Cookie domain
     */
    UkCookieService.prototype.deleteAll = function (path, domain) {
        if (!this.documentIsAccessible) {
            return;
        }
        var cookies = this.getAll();
        for (var cookieName in cookies) {
            if (cookies.hasOwnProperty(cookieName)) {
                this.delete(cookieName, path, domain);
            }
        }
    };
    /**
     * @param name Cookie name
     * @returns RegExp
     */
    UkCookieService.prototype.getCookieRegExp = function (name) {
        var escapedName = name.replace(/([\[\]\{\}\(\)\|\=\;\+\?\,\.\*\^\$])/ig, '\\$1');
        return new RegExp('(?:^' + escapedName + '|;\\s*' + escapedName + ')=(.*?)(?:;|$)', 'g');
    };
    UkCookieService = __decorate([
        Injectable(),
        __param(0, Inject(DOCUMENT)),
        __param(1, Inject(PLATFORM_ID)),
        __metadata("design:paramtypes", [Object, InjectionToken])
    ], UkCookieService);
    return UkCookieService;
}());

var UK_IDLE_CONFIG = new InjectionToken('UK_IDLE_CONFIG');

var Idle = /** @class */ (function () {
    function Idle(config) {
        this.timeout = config.timeout;
        this.ping = config.ping;
    }
    return Idle;
}());
var UkIdleService = /** @class */ (function () {
    function UkIdleService(config) {
        this.timeoutStart$ = new Subject();
        this.isActive$ = new Subject();
        /**
         * Idle timeout value in seconds.
         * Default equals to 5 minutes.
         */
        this.timeout = 300;
        /**
         * Lapse of time to check if timeout
         * have been completed only for startWatching
         */
        this.pingTime = 5;
        this.isActive = false;
        if (config) {
            this.timeout = config.timeout;
            this.pingTime = config.pingTime;
        }
        this.activityEvents$ = merge(fromEvent(window, 'focus'), fromEvent(document, 'keydown'), fromEvent(document, 'touchstart'), fromEvent(document, 'touchend'), fromEvent(document, 'visibilitychange'), fromEvent(document, 'webkitvisibilitychange'), fromEvent(document, 'mozvisibilitychange'), fromEvent(document, 'msvisibilitychange'), fromEvent(document, 'click'));
        this.idle$ = from(this.activityEvents$);
    }
    /**
     * Start watching for user idle and setup timer and ping.
     */
    UkIdleService.prototype.startWatching = function () {
        var _this = this;
        if (this.idleSubscription) {
            this.idleSubscription.unsubscribe();
        }
        this.inactivityDate = new Date();
        var diffTime = 0;
        // If any of user events is not active for idle-second when start timer.
        this.idleSubscription = this.idle$.pipe(throttleTime(this.pingTime * 1000), tap(function () {
            _this.isIdleDetected = false;
            _this.isTimeout = false;
            diffTime = ((new Date()).getTime() - _this.inactivityDate.getTime());
            _this.inactivityDate = new Date();
        }), filter(function (arr) { return !arr.length; }), tap(function () {
            if (diffTime < _this.timeout * 1000) {
                _this.isActive = true;
                _this.isActive$.next(true);
            }
        }), filter(function () { return diffTime > _this.timeout * 1000; }), tap(function () {
            _this.isActive = false;
            _this.isIdleDetected = true;
            _this.isTimeout = true;
            _this.timeoutStart$.next(_this.timeout);
        })).subscribe();
    };
    /**
     * Stop watching if user is idle
     */
    UkIdleService.prototype.stopWatching = function () {
        if (this.idleSubscription) {
            this.isIdleDetected = false;
            this.isTimeout = false;
            this.isActive = false;
            this.idleSubscription.unsubscribe();
        }
    };
    /**
     * Timeout
     * @returns Observable<boolean>
     */
    UkIdleService.prototype.onTimeout = function () {
        var _this = this;
        return this.timeoutStart$.pipe(filter(function (timeout) { return !!timeout; }), tap(function () {
            _this.isIdleDetected = true;
            _this.isTimeout = true;
            _this.isActive = false;
        }), map(function () { return true; }));
    };
    /**
     * Activity
     * @returns Observable<number>
     */
    UkIdleService.prototype.onActivity = function () {
        var _this = this;
        return this.isActive$.pipe(filter(function (active) { return active && _this.isIdleDetected === false; }), tap(function () { return _this.isActive = true; }), map(function () { return Date.now(); }));
    };
    UkIdleService = __decorate([
        Injectable(),
        __param(0, Optional()), __param(0, Inject(UK_IDLE_CONFIG)),
        __metadata("design:paramtypes", [Object])
    ], UkIdleService);
    return UkIdleService;
}());

var JwtHelperService = /** @class */ (function () {
    function JwtHelperService() {
    }
    /**
     * Decode to Base 64
     * @returns string
     */
    JwtHelperService.prototype.urlBase64Decode = function (str) {
        var output = str.replace(/-/g, '+').replace(/_/g, '/');
        switch (output.length % 4) {
            case 0: {
                break;
            }
            case 2: {
                output += '==';
                break;
            }
            case 3: {
                output += '=';
                break;
            }
            default: {
                throw 'Illegal base64url string!';
            }
        }
        return this.b64DecodeUnicode(output);
    };
    // credits for decoder goes to https://github.com/atk
    JwtHelperService.prototype.b64decode = function (str) {
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        var output = '';
        str = String(str).replace(/=+$/, '');
        if (str.length % 4 === 1) {
            throw new Error("'atob' failed: The string to be decoded is not correctly encoded.");
        }
        for (
        // initialize result and counters
        var bc = 0, bs = void 0, buffer = void 0, idx = 0; 
        // get next character
        (buffer = str.charAt(idx++)); 
        // character found in table? initialize bit storage and add its ascii value;
        ~buffer &&
            ((bs = bc % 4 ? bs * 64 + buffer : buffer),
                // and if not first of each 4 characters,
                // convert the first 8 bits to one ascii character
                bc++ % 4)
            ? (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
            : 0) {
            // try to find character in table (0-63, not found => -1)
            buffer = chars.indexOf(buffer);
        }
        return output;
    };
    JwtHelperService.prototype.b64DecodeUnicode = function (str) {
        return decodeURIComponent(Array.prototype.map
            .call(this.b64decode(str), function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
            .join(''));
    };
    /**
    * Decode token to Base 64
    * @returns string
    */
    JwtHelperService.prototype.decodeToken = function (token) {
        if (token === void 0) { token = this.tokenGetter(); }
        if (token === null) {
            return null;
        }
        var parts = token.split('.');
        if (parts.length !== 3) {
            throw new Error('The inspected token doesn\'t appear to be a JWT. Check to make sure it has three parts and see https://jwt.io for more.');
        }
        var decoded = this.urlBase64Decode(parts[1]);
        if (!decoded) {
            throw new Error('Cannot decode the token.');
        }
        return JSON.parse(decoded);
    };
    /**
     * Gets the expiraton date from a token
     * @returns Date
     */
    JwtHelperService.prototype.getTokenExpirationDate = function (token) {
        if (token === void 0) { token = this.tokenGetter(); }
        var decoded;
        decoded = this.decodeToken(token);
        if (!decoded.hasOwnProperty('exp')) {
            return null;
        }
        var date = new Date(0);
        date.setUTCSeconds(decoded.exp);
        return date;
    };
    /**
     * Gets if the token is valid
     * @returns Boolean
     */
    JwtHelperService.prototype.isTokenExpired = function (token, offsetSeconds) {
        if (token === void 0) { token = this.tokenGetter(); }
        if (token === null || token === '') {
            return true;
        }
        var date = this.getTokenExpirationDate(token);
        offsetSeconds = offsetSeconds || 0;
        if (date === null) {
            return true;
        }
        return !(date.valueOf() > new Date().valueOf() + offsetSeconds * 1000);
    };
    JwtHelperService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [])
    ], JwtHelperService);
    return JwtHelperService;
}());

var UK_COOKIE_HANDLER_CONFIG = new InjectionToken('UK_COOKIE_HANDLER_CONFIG');

var UkHandlerService = /** @class */ (function () {
    function UkHandlerService(config, uKIdleService, cookieService, jwtHelperService) {
        this.uKIdleService = uKIdleService;
        this.cookieService = cookieService;
        this.jwtHelperService = jwtHelperService;
        this.timeOut = 300;
        this.limitTime = 60;
        this.timeToTakeAction = 30;
        this.refreshTime = 60;
        this.refreshToken$ = new Subject();
        this.warningAlert$ = new Subject();
        this.watcherTimeout = new Subscription();
        this.activityWatcher = new Subscription();
        if (config) {
            this.timeOut = config.timeOut;
            this.limitTime = config.limitTime;
            this.refreshTime = config.refreshTime || 450;
            this.timeToTakeAction = config.timeToTakeAction || 30;
        }
    }
    /**
     * Get the cookie and if it's null, return and fire warning alert
     * @returns string
     */
    UkHandlerService.prototype.getToken = function () {
        var cookie = this.cookieService.get('XSRF-TOKEN');
        return cookie ? this.jwtHelperService.decodeToken(cookie) : null;
    };
    /**
     * Get the token expiration
     * @returns number
     */
    UkHandlerService.prototype.getTokenExp = function () {
        return this.getTiming(this.getToken())[1];
    };
    UkHandlerService.prototype.setToken = function (tokenExp) {
        var now = new Date();
        this.lastRefresh = now.getTime();
        this.setExpWarning(tokenExp, now);
        this.listenActivity();
    };
    UkHandlerService.prototype.checkExpWarning = function () {
        var now = new Date();
        var tokenExp = this.getTokenExp();
        this.setExpWarning(tokenExp, now);
    };
    UkHandlerService.prototype.setExpWarning = function (tokenExp, now) {
        var _this = this;
        var warnDate = new Date((tokenExp - this.limitTime) * 1000);
        var lastWarnDate = new Date((tokenExp - this.timeToTakeAction) * 1000);
        var inactivityWarnDate = new Date(this.lastActivity + (this.timeOut * 1000));
        warnDate = new Date(Math.max(warnDate.getTime(), inactivityWarnDate.getTime()));
        if (warnDate > lastWarnDate) {
            warnDate = lastWarnDate;
        }
        var timeLeftToWarnUser = warnDate.getTime() - now.getTime();
        if (timeLeftToWarnUser > 0) {
            // Delete existing subscription
            if (this.watcherTimeout) {
                this.watcherTimeout.unsubscribe();
            }
            this.warningTimer$ = timer(timeLeftToWarnUser);
            this.watcherTimeout = this.warningTimer$.subscribe(function () { return _this.checkExpWarning(); });
        }
        else {
            this.warningAlert$.next();
        }
    };
    UkHandlerService.prototype.listenActivity = function () {
        var _this = this;
        this.uKIdleService.startWatching(); // Start Idle Service
        if (this.activityWatcher) {
            this.activityWatcher.unsubscribe();
        }
        this.activityWatcher = this.uKIdleService.onActivity()
            .pipe(map(function (lastActivity) {
            _this.lastActivity = lastActivity;
            return (lastActivity - _this.lastRefresh) / 1000;
        })).subscribe(function (ellapsedTime) {
            if (ellapsedTime > _this.refreshTime) {
                _this.refreshToken$.next();
            }
        });
    };
    /**
     * Syncs cookie and initializes startWatching method from UKIdleService
     */
    UkHandlerService.prototype.initialize = function () {
        this.uKIdleService.startWatching();
        this.lastActivity = Date.now();
        this.initializeTimer();
    };
    /**
     * Gets difference between expiration date and actual date based on expiration from token.
     * @returns [number, number]
     */
    UkHandlerService.prototype.getTiming = function (token) {
        var tokenExp = token.exp !== null ? token.exp : 0;
        var difference = tokenExp - parseInt((new Date().getTime() / 1000).toFixed());
        // Get the half of the timelife of token
        var timing = difference - this.timeOut;
        return [timing * 1000, tokenExp];
    };
    // tslint:disable: curly
    /**
     * Gets the cookie and starts timer storing in a subscription
     */
    UkHandlerService.prototype.initializeTimer = function () {
        var token = this.getToken();
        if (!token) {
            return this.warningAlert$.next();
        }
        this.setToken(this.getTiming(token)[1]);
    };
    /**
     * Indicates a new token was set and starts timer again
     */
    UkHandlerService.prototype.isTokenUpdated = function () {
        this.initializeTimer();
    };
    /**
     * This will shoot after half life of token have passed
      * @returns Observable<boolean>
     */
    UkHandlerService.prototype.refreshToken = function () {
        var _this = this;
        return this.refreshToken$.pipe(tap(function () { return _this.uKIdleService.stopWatching(); }), map(function () { return true; }));
    };
    /**
     * This will shoot a certain time before the token is going to expire
     * @returns Observable<boolean>
     */
    UkHandlerService.prototype.sessionExpirationWarning = function () {
        var _this = this;
        return this.warningAlert$.pipe(tap(function () {
            _this.uKIdleService.stopWatching();
            _this.isWarned = true;
            _this.watcherTimeout.unsubscribe();
        }), map(function () { return true; }));
    };
    UkHandlerService = __decorate([
        Injectable(),
        __param(0, Optional()), __param(0, Inject(UK_COOKIE_HANDLER_CONFIG)),
        __metadata("design:paramtypes", [Object, UkIdleService,
            UkCookieService,
            JwtHelperService])
    ], UkHandlerService);
    return UkHandlerService;
}());

var UkAuthenticationModule = /** @class */ (function () {
    function UkAuthenticationModule() {
    }
    UkAuthenticationModule = __decorate([
        NgModule({
            imports: [
                ReactiveFormsModule,
                FormsModule,
                CommonModule,
                UkFormControlsModule,
                UkDropdownModule,
                UIKitCommonModule,
                UIKitIconsModule
            ],
            declarations: [
                UkLoginComponent,
                UkRecoveryComponent,
                UkVerificationMethodsComponent,
                UkVerificationCodeComponent,
                UkSecurityQuestionsComponent
            ],
            exports: [
                UkLoginComponent,
                UkRecoveryComponent,
                UkVerificationMethodsComponent,
                UkVerificationCodeComponent,
                UkSecurityQuestionsComponent
            ],
            providers: [
                UkCookieService,
                UkIdleService,
                JwtHelperService,
                UkHandlerService
            ]
        })
    ], UkAuthenticationModule);
    return UkAuthenticationModule;
}());

export { Idle, JwtHelperService, RecoveryField, UK_COOKIE_HANDLER_CONFIG, UK_IDLE_CONFIG, UkAuthenticationModule, UkCookieService, UkHandlerService, UkIdleService, UkLoginComponent as ɵa, UkRecoveryComponent as ɵb, UkVerificationMethodsComponent as ɵc, UkVerificationCodeComponent as ɵd, UkSecurityQuestionsComponent as ɵe };
//# sourceMappingURL=uikit-components-uk-authentication.js.map
